import {createFileRoute} from '@tanstack/react-router'
import {WalletSwapZenex} from '@/components/wallet/WalletSwapZenex/WalletSwapZenex'

export const Route = createFileRoute('/_mainLayout/wallet/swap-zenex/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WalletSwapZenex />
}
